import { DataTableStoreState } from "../store/DataTableProvider.types";
import { ModalEditDataTable } from "./ModalEditDataTable";
import { ModalEditExecutableTable } from "./ModalEditExecutableTable";

interface ModalEditTableProps {
  table: DataTableStoreState["tables"][number];
  onClose: () => void;
}

/** Component that renders a modal for updating a table of any kind */
export const ModalEditTable = ({ table, onClose }: ModalEditTableProps) =>
  table.kind === "data" ? (
    <ModalEditDataTable table={table} onClose={onClose} />
  ) : (
    <ModalEditExecutableTable table={table} onClose={onClose} />
  );
